

























































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { GrantData, FinancialReportData } from "@/entities";
import { Utilities as utils } from "@/shared/utilities";
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import NavButtons from '@/components/common/Buttons/NavButtons.vue';
import ImportButton from '@/components/common/Buttons/ImportButtons.vue';
import ProgressBar from '@/components/common/ProgressBar/ProgressBar.vue';
import { AppConstants as _app } from '@/shared/app.constants';
import PermissionService from '@/services/permission.service';
import { Locales } from "@/i18n/locales";

const namespace: string = "financialReport";
const permissionService = new PermissionService();

@Component({
    components: {
        WorkflowButtons,
        ValidationMessageComponent,
        NavButtons,
        ImportButton,
        ProgressBar
    }
})
export default class FinancialReportSummary extends Vue {

    @State(namespace) financialReport!: FinancialReportData;
    @Action("saveFinancialReport", { namespace }) saveReport: any;
    @Action("saveFinancialReportData", { namespace }) saveReportData: any;    
    @Action('getAppBudgetForGrant', {namespace}) getAppBudgetForGrant: any;
    @Getter('grantInfo', {namespace}) grantInfo: any;
    @Prop() financialReportSections: any;
    @Prop() schema: any;
    @Prop() isDirty: any;
    @Prop() enableButton: any;
    @Prop() initiativeId: any;
    @Prop() permitted:boolean;
    actions = _app.actions;
    subjects = _app.subjects;
    actionEnable = [
        _app.finReportStatus.readyForAudit,
        _app.finReportStatus.pendingReview,
        _app.finReportStatus.readyForValidation,
        _app.finReportAuditStatus.readyForAudit,
        _app.finReportAuditStatus.pendingReview,
        _app.finReportAuditStatus.validated
    ];
    selectedSection:any
    $refs!: {
        uploader: HTMLFormElement;
        workflowButtonRef: WorkflowButtons;
    }
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    mounted() {
      /*let params =  {
        id : this.financialReport.grantData.grantId,
        financialReportId : this.financialReport.selectedReport.FinancialReportId,
        period : this.financialReport.selectedReport.Title
      }
      this.getAppBudgetForGrant(params);*/
    }

    formatCurrency(val, currency) {
        return utils.formatCurrency(val, currency, this.defaultLocale);
    }
    uploadTemplate(){
        this.$refs.uploader.click()
    }
    
    onFileSelected(e, type){
        this.$emit('onAddFiles',{file:e.target.files[0],type})
    }

    // ppoHasPermission(initiativeId: any) {
    //     // Get logged in user initiatives
    //     permissionService.ppoHasPermission(initiativeId).then((hasPermission: boolean) => {
    //         this.permitted = hasPermission;
    //     });
    // }

    /** computed property workflow items */
    get workFlowItems() {
        return this.financialReport.selectedReport.WorkflowInfo || {}
    }

    /** show validations */
    showValidation(msgs: any) {
        this.financialReport.validationMessages = msgs;
        this.financialReport.showValidationDilog = true;
    }

    // redirect to application form on validation message click
    validationMessageClicked(msg: any) {
        this.financialReport.showValidationDilog = false;
        this.financialReport.validationMessages = [];     
    }

    validationMessageClosed() {
        this.financialReport.showValidationDilog = false;
        this.financialReport.validationMessages = [];
        this.$refs.workflowButtonRef.enableAllButtons();
    }

    /** pre validation action */
    preValidation() {
        const self = this;
        /** transform forecast model */
        let result = this.$services.monitor.transformAppData(self.financialReport.grantData);
        return this.saveReportData({
            data: this.$services.monitor.mergeBudgetSummary(result, self.financialReport.applicationBudgetForGrant, self.financialReport.selectedReport.FinancialReportId),
            id: self.financialReport.selectedReport.GrantId,
            reportId: self.financialReport.selectedReport.FinancialReportId,
            context: 'submit'
        })
        .then((data) => {
            this.$emit("validations", data.Validation);

            let validationErrors = [];

            // Get all errors
            Object.keys(data.Validation).forEach(key => {
            const item = data.Validation[key];
            if (item && item.Validation) {
                validationErrors = validationErrors.concat(item.Validation);
            }
            });
            
            return {validationErrors};
            });
    }

    /** update status on workflow btn click */
    updateStatus(item) {
        const self = this;
        this.financialReport.selectedReport.WorkFlowStatusId = item.StepId;
        this.financialReport.selectedReport.Comments = item.Comments;
        this.financialReport.selectedReport.Subject = item.Subject;
        this.financialReport.selectedReport.notify = item.notify;
        this.saveReport({
            data: self.financialReport.selectedReport,
            id: self.financialReport.selectedReport.FinancialReportId
        }).then(resp => { 
            if(resp) {
                this.$refs.workflowButtonRef.enableAllButtons();
                this.$router.push({
                    name: "grantSummary",
                    params: { grantId: self.financialReport.selectedReport.GrantId.toString() }
                }); 
            }
        });
    }
    downloadTemplate()
    {
        this.$emit("downloadTemp",{})
    }
    downloadExcel()
    {
        this.$emit("downloadExcel",{})
    }
    // @Watch("initiativeId")
    // ppoPermission(val: any) {
    //     if (val) {
    //         this.ppoHasPermission(val);
    //     } else {
    //         this.permitted = false;
    //     }
    // }
    
}
